import { Modal } from 'antd';
import { formatNumber, numberToMoneyStr } from '../../entities/util-functions';
import { CloseIcon, Subtitle } from '../shared';
import { IExpenseItem } from '../../entities/budget.entities';
import { useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';

interface Props {
  items: IExpenseItem[];
  visible: boolean;
  onClose: () => void;
  className?: string;
}

const GrowerDetailModal = ({ items, visible, onClose, className }: Props) => {
  const lang = useSelector(selectLang);
  const amountSum = items.reduce((p, c) => p + c.amount, 0);
  const qtySum = items.reduce((p, c) => p + (c.quantity ?? 0), 0);

  return (
    <Modal
      visible={visible}
      onCancel={onClose}
      className={className}
      closable
      closeIcon={<CloseIcon />}
      width={600}
      footer={null}
    >
      <div className='section-modal wrap'>
        <div className='d-flex align-center mb-17'>
          <Subtitle color='black-1' align='left' size={1} fontWeight={600}>
            {translate(lang, 'Harvest Items')}
          </Subtitle>
        </div>
        <div className='mb-17'>
          <div className='item-row'>
            <div className='item-cell'>{translate(lang, 'Item')}</div>
            <div className='item-cell'>{translate(lang, 'Quantity')}</div>
            <div className='item-cell'>{translate(lang, 'Unit Price')}</div>
            <div className='item-cell'>{translate(lang, 'Amount')}</div>
          </div>
          <div className='section mb-0'>
            {items.map((x, i) => (
              <div className='item-row' key={i}>
                <div className='item-cell'>{x.name}</div>
                <div className='item-cell'>
                  {x.quantity ? formatNumber(x.quantity) : '-'}
                </div>
                <div className='item-cell'>
                  {x.quantity ? formatNumber(x.amount / x.quantity) : '-'}
                </div>
                <div className='item-cell'>{numberToMoneyStr(x.amount)}</div>
              </div>
            ))}
          </div>
          <div className='item-row strong'>
            <div className='item-cell'>{translate(lang, 'Total')}</div>
            <div className='item-cell'>{formatNumber(qtySum)}</div>
            <div className='item-cell'></div>
            <div className='item-cell'>{numberToMoneyStr(amountSum)}</div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default GrowerDetailModal;
